import { __spreadArray } from "tslib";
var getImageQueryProps = function (operations) {
    return Object.keys(operations)
        .map(function (k) { return k + "_" + operations[k]; })
        .join(',');
};
// NOTE: Make sure that ImageWithLoader from composer still works if you change this.
export var adjustImage = function (fileName, ops) {
    if (fileName.startsWith('http')) {
        return fileName;
    }
    var operationsArray = Array.isArray(ops)
        ? __spreadArray([], ops) : [
        {
            type: 'fit',
            operations: ops,
        },
    ];
    var operationParts = operationsArray.map(function (_a) {
        var type = _a.type, operations = _a.operations;
        return "/" + type + "/" + getImageQueryProps(operations);
    });
    return "https://images.wixstatic.com/media/" + fileName + "/v1" + operationParts.join('') + "/" + fileName;
};
//# sourceMappingURL=adjust-image.js.map